import { render, staticRenderFns } from "./TableListConfig.vue?vue&type=template&id=1c571a05&scoped=true"
import script from "./TableListConfig.vue?vue&type=script&lang=js"
export * from "./TableListConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c571a05",
  null
  
)

export default component.exports